import { ResultTypes } from './index.d';

export const TITLES = {
    [ResultTypes.affiliate]: 'Affiliate products',
    [ResultTypes.notAffiliate]: 'Non-affiliate products',
    [ResultTypes.notParticipate]: 'Cannot advertise due to AliExpress policy',
    [ResultTypes.wrong]: 'The link does not lead to a product page',
};

export const RU_LINKS = ['https://aliexpress.com', 'https://ru.aliexpress.com'];
export const EN_LINKS = ['https://aliexpress.com'];
export const ERRORS_MESSAGES = {
    isAllLinksRight: 'One or more links are not AliExpress links',
    lessThanTen: 'You can check up to 10 links at once',
};

export const SCHEME_LINKS = {
    en: 'https://cdn1.epn.bz/public/0f5a3f5917c937a4b5d455c75c0c0be4.jpg',
    ru: 'https://cdn1.epn.bz/public/cc99d78da2bba78d14a3d613f1c662bd.jpg',
};

export const GROUPS = {
    0: ResultTypes.wrong,
    1: ResultTypes.affiliate,
    2: ResultTypes.notAffiliate,
    3: ResultTypes.notParticipate,
};
